import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  output,
  signal,
  viewChildren
} from "@angular/core";

import { Tab } from "./tabs.model";

export type TabVariant = 'underline' | 'segment';

@Component({
  selector: "component-tabs",
  templateUrl: "./tabs.component.html",
  styleUrls: ["./tabs.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabsComponent implements AfterViewInit {
  readonly tabs = input.required<Tab[]>();
  readonly activeTab = input.required<Tab>();
  readonly variant = input<TabVariant>('underline');
  readonly tabChange = output<Tab>();

  protected readonly underlineLeft = signal(0);
  protected readonly underlineWidth = signal(0);
  private readonly _tabButtons = viewChildren<ElementRef<HTMLButtonElement>>("tabButton");

  ngAfterViewInit(): void {
    setTimeout(() => this.updateUnderlinePosition(), 0);
  }

  protected onTabChange(tab: Tab, element: HTMLButtonElement): void {
    this.tabChange.emit(tab);
    this.updateUnderlinePosition(element);
  }

  private updateUnderlinePosition(element?: HTMLButtonElement): void {
    let activeTabElement: HTMLButtonElement | undefined = element;
    if (!activeTabElement) {
      const activeIndex = this.tabs().findIndex((tab) => tab.id === this.activeTab().id);
      if (activeIndex > -1) {
        activeTabElement = this._tabButtons()[activeIndex]?.nativeElement;
      }
    }

    if (activeTabElement) {
      this.underlineLeft.set(activeTabElement.offsetLeft);
      this.underlineWidth.set(activeTabElement.offsetWidth);
    }
  }
}
